import React from "react"
import TopLayout from "./src/components/topLayout"

export const wrapPageElement = ({ element }) => {
  return <TopLayout>{element}</TopLayout>
}
